import * as React from 'react';
import {emulateCouleurTextile} from "../UploadUtils";
import {getShopRefInStorage} from "../../MonCompteAction";

interface ThumbnailsControProps {
  styleFibreTextile:  any,
  bgColor: string,
  pathLoadDilatation: string,
  pathLoadBat: string,
  outlineProcessing: string,
  marquageId: number,
  isInternalUser: boolean,
  controlPreviewActiv: number,
  handleClickControlImage: (id: number, viewed:boolean, clicked: boolean ) => void
}

export const ThumbnailsControl = (props: ThumbnailsControProps) => {
  const hasDilationImg = props.pathLoadDilatation && props.pathLoadDilatation !== '';
  const showDilationImg = props.isInternalUser && hasDilationImg && props.outlineProcessing === 'etendu' && (props.marquageId == 3 || props.marquageId == 2) ;
  if(props.pathLoadBat) {
    return (
      <div  className={'my-2 imgControls d-flex justify-center align-self-center'}>
        <div style={{height: '90px', width: '90px'}} className={`  imgControlsChild mb-1 mr-2 justify-center  d-flex align-items-center ${props.controlPreviewActiv === 0 ? ' controlPreviewActiv ' : '' } `}>
          <div className={'h-100 d-flex align-items-center p-1'} onClick={() => props.handleClickControlImage(0, true, true)}   style={getShopRefInStorage() !== 'DT' ? props.styleFibreTextile : {}} >
            <img className='imgControlZoom' src={props.pathLoadBat} style={emulateCouleurTextile(props.bgColor, props.outlineProcessing, {maxHeight: '100%'})} />
          </div>
        </div>
        <div style={{height: '90px', width: '90px'}} className={` imgControlsChild mb-1 mr-2 justify-center  d-flex align-items-center  ${props.controlPreviewActiv === 1 ? ' controlPreviewActiv ' : '' } `}>
          <div className={'h-100 d-flex align-items-center p-1 bg-alpha-bat-auto'} onClick={() => props.handleClickControlImage(1, true, true)}  >
            <img className='imgControlZoom' src={props.pathLoadBat} style={emulateCouleurTextile(props.bgColor, props.outlineProcessing, {maxHeight: '100%'})}  />
          </div>
        </div>
        <div style={{height: '90px', width: '90px'}} className={` imgControlsChild mb-1 mr-2 justify-center  d-flex align-items-center  ${props.controlPreviewActiv === 2 ? ' controlPreviewActiv ' : '' } `}>
          <div className={'h-100 d-flex align-items-center p-1 bg-white'}  onClick={() => props.handleClickControlImage(2, true, true)}  >
            <img className='imgWhiteToBlack' src={props.pathLoadBat} style={emulateCouleurTextile(props.bgColor, props.outlineProcessing, {maxHeight: '100%'})}  />
          </div>
        </div>
        {showDilationImg &&
          <div  className={'imgControls d-flex justify-center align-self-center'}>
            <div style={{height: '90px', width: '90px'}} className={` imgControlsChild mb-1 mr-2 justify-center  d-flex align-items-center  ${props.controlPreviewActiv === 3 ? ' controlPreviewActiv ' : '' } `}>
              <div className={'h-100 d-flex align-items-center p-1 '}  style={{backgroundColor: props.bgColor }}   onClick={() => props.handleClickControlImage(3, true, true)} >
                <img className='showImgDilatationZoom' src={props.pathLoadDilatation} style={emulateCouleurTextile(props.bgColor, props.outlineProcessing, {maxHeight: '100%'})}  />
              </div>
            </div>
          </div>
        }
      </div>
    );
  } else {
    return null;
  }
}
